import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(() => ({
  header: {
    color: "red",
  },
  subHeader: {
    color: "teal",
    fontWeight: "fontWeightLight",
  },
}));

interface PublicUserInfoProps {
  userData: {
    displayName: string;
    joinDate: string;
    profileBio: string;
  } | null;
}

function PublicUserInfo({ userData }: PublicUserInfoProps) {
  const classes = useStyles();

  return (
    <>
      {userData ? (
        <>
          <h3 className={classes.header}>User Info</h3>
          <h5>
            <span className={classes.subHeader}>Display name: </span>
            {userData.displayName}
          </h5>
          <h5>
            <span className={classes.subHeader}>Join Date: </span>
            {userData.joinDate}
          </h5>
          <h5>
            <span className={classes.header}>Bio </span>
          </h5>
          <Typography component="div">
            <Box fontWeight="fontWeightLight" m={1}>
              <p
                className="player-bio"
                dangerouslySetInnerHTML={{
                  __html: userData.profileBio,
                }}
              />
            </Box>
          </Typography>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default PublicUserInfo;
